import { Component, OnInit, Input, Output, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Repository } from '../../../services/repository';

declare let swal: any;
declare let $: any; // Declare jQuery if available

@Component({
  selector: 'app-taothuhocphi',
  templateUrl: './taothuhocphi.component.html',
  styleUrls: ['./taothuhocphi.component.scss']
})
export class TaothuHocPhiComponent implements OnInit, AfterViewInit {
  @Input() Id: any;
  @Input() quyen_sua: boolean = true;
  @Output() save = new EventEmitter();

  doituongSelect: any = {};
  phieuThu: any = {};

  // Collapsible panel states
  isHocPhiCollapsed: boolean = false;  // Panel 1 mở mặc định
  isThuTienCollapsed: boolean = false;  // Panel 2 đóng mặc định
  isXacNhanCollapsed: boolean = false;  // Panel 3 đóng mặc định

  // Data arrays
  thuTruocOptions: any[] = [];
  inputhinhthucs: any = [
    { Ten: 'Thanh toán hết', Id: 0 },
    { Ten: 'Đặt cọc', Id: 1 },
    { Ten: 'Thanh toán 1 phần', Id: 2 }
  ];
  inputphuongthucs: any = [
    { Ten: 'Tiền mặt', Id: 0 },
    { Ten: 'Chuyển khoản', Id: 1 },
    { Ten: 'Quẹt thẻ', Id: 2 },
    { Ten: 'Trả góp', Id: 3 },
    { Ten: 'Không có', Id: 4 },
  ];

  // Current user and other properties
  currentUser: any;
  dviid: any;
  isSubmitting: boolean = false;

  // Currency options
  ngxCurrencyOptions = {
    align: "right",
    allowNegative: false,
    allowZero: true,
    decimal: ",",
    precision: 0,
    prefix: "",
    suffix: "",
    thousands: ".",
    nullable: true
  };

  private currentHocVienId: string = '';
  private currentTongTienConLai: number = 0;
  private currentLopId: string = '';

  constructor(
    private repo: Repository,
    private route: ActivatedRoute
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');
    this.dviid = this.currentUser.donvi_id;
  }

  ngOnInit(): void {
    this.initializeThuTruocOptions();
    this.initializeDefaultValues();
    //this.loadData();
    this.loadComboBoxData();
  }

  ngAfterViewInit() {
    // Initialize Bootstrap collapse functionality if jQuery is available
    setTimeout(() => {
      this.initializeCollapse();
    }, 100);
  }

  initializeCollapse() {
    // Try to use jQuery Bootstrap if available
    if (typeof $ !== 'undefined' && $.fn.collapse) {
      // Set up collapse event handlers
      $('.collapse').on('show.bs.collapse', function () {
        const button = $(this).prev().find('button');
        button.removeClass('collapsed');
        button.find('.fa-chevron-down').removeClass('fa-chevron-down').addClass('fa-chevron-up');
      });

      $('.collapse').on('hide.bs.collapse', function () {
        const button = $(this).prev().find('button');
        button.addClass('collapsed');
        button.find('.fa-chevron-up').removeClass('fa-chevron-up').addClass('fa-chevron-down');
      });
    }
  }

  // Manual toggle methods for panels
  toggleHocPhiPanel() {
    this.isHocPhiCollapsed = !this.isHocPhiCollapsed;
    if (typeof $ !== 'undefined' && $.fn.collapse) {
      $('#collapseHocPhi').collapse('toggle');
    }
  }

  toggleThuTienPanel() {
    this.isThuTienCollapsed = !this.isThuTienCollapsed;
    if (typeof $ !== 'undefined' && $.fn.collapse) {
      $('#collapseThuTien').collapse('toggle');
    }
  }

  toggleXacNhanPanel() {
    this.isXacNhanCollapsed = !this.isXacNhanCollapsed;
    if (typeof $ !== 'undefined' && $.fn.collapse) {
      $('#collapseXacNhan').collapse('toggle');
    }
  }

  // Method to toggle panels programmatically if needed
  togglePanel(panelId: string) {
    if (typeof $ !== 'undefined' && $.fn.collapse) {
      $(`#${panelId}`).collapse('toggle');
    }
  }

  initializeThuTruocOptions() {
    this.thuTruocOptions = [];
    for (let i = 1; i <= 12; i++) {
      this.thuTruocOptions.push({
        id: i,
        name: `${i} Tháng`
      });
    }
  }

  loadDataInit(phanHeId: string, id: any, donViId: string, hocVienId: string, tongTienConLai: number, lopId?: string) {
    this.dviid = donViId;

    // Lưu trữ tham số để sử dụng khi reload 
    this.currentHocVienId = hocVienId;
    this.currentTongTienConLai = tongTienConLai;
    this.currentLopId = lopId || '';

    // Gọi initializeDefaultValues TRƯỚC
    this.initializeDefaultValues();
    this.loadComboBoxData();

    // Set giá trị mặc định SAU khi đã khởi tạo
    this.phieuThu.HinhThuc = 0;
    this.phieuThu.PhuongThuc = 1;

    this.repo.postRequest('api/quanlythuchi/get_maphieu', { DonViId: donViId, LoaiPhieu: 2 }) 
      .subscribe(response => {
        this.phieuThu.SoPhieu = response;
      });

    // Load thông tin học viên và học phí
    if (hocVienId) {
      this.loadHocVienInfo(hocVienId);
      this.loadHocPhiInfo(hocVienId, tongTienConLai, lopId, 1);
    }
  }

  private loadHocVienInfo(hocVienId: string) {
    this.repo.getRequest('api/hocvien/get', {
      donviid: this.dviid,
      username: this.currentUser.user_name,
      id: hocVienId
    }).subscribe(result => {
      if (result.success && result.data) {
        // Populate học viên information if needed
      }
    });
  }
  hocPhiList: any[] = [];

  // Cập nhật phương thức loadHocPhiInfo để xử lý nhiều tháng
  private loadHocPhiInfo(hocVienId: string, tongTienConLai: number, lopId: string, soThang: number) {
    
    this.repo.getRequest('api/hocvien/loadtaothuhocphi', {
      donviid: this.dviid,
      username: this.currentUser.user_name,
      lopid: lopId,
      thuTruoc: soThang,
      hocvienid: hocVienId
    }).subscribe(result => {
      if (result.success && result.data) {
        if (Array.isArray(result.data)) {
          // Trường hợp trả về nhiều tháng
          this.hocPhiList = result.data.map(item => ({
            ...item,
            ThucThu: item.GiaPhi || 0 // Khởi tạo ThucThu = GiaPhi
          }));
          // Lấy tháng đầu tiên làm dữ liệu chính
          this.doituongSelect = this.hocPhiList[0] || {};
        } else {
          // Trường hợp trả về 1 tháng
          result.data.ThucThu = result.data.GiaPhi || 0;
          this.doituongSelect = result.data;
          this.hocPhiList = [result.data];
        }

        this.phieuThu.SoTien = this.getTotalThucThu();
        this.convertDates();
        console.log('Học phí data:', this.hocPhiList);
      }

    });
  }

  // Thêm phương thức tính tổng số buổi
  getTotalSoBuoi(): number {
    if (!this.hocPhiList || this.hocPhiList.length === 0) {
      return this.doituongSelect.SoBuoi || 0;
    }
    return this.hocPhiList.reduce((total, item) => total + (item.SoBuoi || 0), 0);
  }

  // Thêm phương thức tính tổng học phí với tham số includeOldDebt
  getTotalHocPhi(includeOldDebt: boolean = true): number {
    if (!this.hocPhiList || this.hocPhiList.length === 0) {
      return this.doituongSelect.GiaPhi || 0;
    }

    // Lọc dữ liệu dựa trên tham số includeOldDebt
    const filteredList = includeOldDebt
      ? this.hocPhiList // Lấy tất cả
      : this.hocPhiList.filter(item => !item.Id || item.Id === null); // Chỉ lấy dòng không có Id (công nợ mới)

    return filteredList.reduce((total, item) => total + (item.GiaPhi || 0), 0);
  }

  // Thêm phương thức tính tổng thực thu với tham số includeOldDebt
  getTotalThucThu(includeOldDebt: boolean = true): number {
    if (!this.hocPhiList || this.hocPhiList.length === 0) {
      return this.doituongSelect.ThucThu || 0;
    }

    // Lọc dữ liệu dựa trên tham số includeOldDebt
    const filteredList = includeOldDebt
      ? this.hocPhiList // Lấy tất cả
      : this.hocPhiList.filter(item => !item.Id || item.Id === null); // Chỉ lấy dòng không có Id (công nợ mới)

    return filteredList.reduce((total, item) => total + (item.ThucThu || 0), 0);
  }

  initializeDefaultValues() {
    this.doituongSelect = {
      Id: null,
      NgayDangKy: null,
      NgayKetThuc: null,
      GhiChu: '',
      SoBuoi: 0,
      GiaPhi: 0,
      DuocGiam: 0,
      ThucThu: 0
    };

    this.phieuThu = {
      QuyenSo: '',
      SoPhieu: null,
      ThuTruoc: 1, // Default to 1 month
      SoTien: 0,
      HinhThuc: 0,        // Set mặc định ở đây
      PhuongThuc: 1,      // Set mặc định ở đây
      NgayChungTu: new Date(),
      GhiChu: ''
    };
   
    this.hocPhiList = [];
  }



  loadComboBoxData() {
   
  }

  convertDates() {
    if (this.hocPhiList && this.hocPhiList.length > 0) {
      this.hocPhiList.forEach(item => {
        if (item.NgayDangKy) {
          item.NgayDangKy = new Date(item.NgayDangKy);
        }
        if (item.NgayKetThuc) {
          item.NgayKetThuc = new Date(item.NgayKetThuc);
        }
      });
    }

    // Xử lý cho doituongSelect như cũ
    if (this.doituongSelect.NgayDangKy) {
      this.doituongSelect.NgayDangKy = new Date(this.doituongSelect.NgayDangKy);
    }
    if (this.doituongSelect.NgayKetThuc) {
      this.doituongSelect.NgayKetThuc = new Date(this.doituongSelect.NgayKetThuc);
    }
    if (this.phieuThu.NgayChungTu) {
      this.phieuThu.NgayChungTu = new Date(this.phieuThu.NgayChungTu);
    }
  }

  comboSearchFn2(term: string, item: any) {
    term = term.toLowerCase();
    return item.Ten.toLowerCase().indexOf(term) > -1;
  }

  changeDuocGiam() {
    const duocGiam = this.doituongSelect.DuocGiam || 0;

    if (this.hocPhiList && this.hocPhiList.length > 0) {
      // Tính toán cho từng dòng trong bảng
      this.hocPhiList.forEach(item => {
        if (item.GiaPhi) {
          if (duocGiam > 100) {
            // Giảm số tiền cố định
            item.ThucThu = Math.max(0, item.GiaPhi - duocGiam);
          } else {
            // Giảm phần trăm
            item.ThucThu = Math.max(0, item.GiaPhi * (100 - duocGiam) / 100);
          }
        } else {
          item.ThucThu = 0;
        }
      });

      // Cập nhật lại doituongSelect từ dòng đầu tiên
      if (this.hocPhiList.length > 0) {
        this.doituongSelect.ThucThu = this.hocPhiList[0].ThucThu;
      }
    } else {
      // Trường hợp chỉ có 1 dòng
      if (this.doituongSelect.GiaPhi) {
        if (duocGiam > 100) {
          // Giảm số tiền cố định
          this.doituongSelect.ThucThu = Math.max(0, this.doituongSelect.GiaPhi - duocGiam);
        } else {
          // Giảm phần trăm
          this.doituongSelect.ThucThu = Math.max(0, this.doituongSelect.GiaPhi * (100 - duocGiam) / 100);
        }
      } else {
        this.doituongSelect.ThucThu = 0;
      }
    }

    // Cập nhật số tiền thu theo số tháng
    this.phieuThu.SoTien = this.getTotalThucThu();
  }

  changeThuTruoc(value: any) {
    const newSoThang = value.id;
    this.phieuThu.ThuTruoc = newSoThang;

    // Gọi lại loadHocPhiInfo với số tháng mới
    if (this.currentHocVienId) {
      this.loadHocPhiInfo(this.currentHocVienId, this.currentTongTienConLai, this.currentLopId, newSoThang);
    }
  }
  getThuTruocName(id: number): string {
    const option = this.thuTruocOptions.find(opt => opt.id === id);
    return option ? option.name : '';
  }

  saveproduct() {
    if (this.isSubmitting) return;

    // Validation (giữ nguyên code validation hiện tại)
    if (!this.phieuThu.SoPhieu) {
      swal('Lỗi!', 'Vui lòng nhập số phiếu!', 'error');
      return;
    }

    // ... other validations ...

    // Validate string lengths
    const validationErrors: string[] = [];

    if (this.doituongSelect.LyDoGiam && this.doituongSelect.LyDoGiam.length > 500) {
      validationErrors.push('Lý do giảm không được vượt quá 500 ký tự');
    }

    if (this.doituongSelect.GhiChu && this.doituongSelect.GhiChu.length > 500) {
      validationErrors.push('Ghi chú học phí không được vượt quá 500 ký tự');
    }

    if (this.phieuThu.QuyenSo && this.phieuThu.QuyenSo.length > 50) {
      validationErrors.push('Quyển số không được vượt quá 50 ký tự');
    }

    if (this.phieuThu.GhiChu && this.phieuThu.GhiChu.length > 500) {
      validationErrors.push('Ghi chú phiếu thu không được vượt quá 500 ký tự');
    }

    if (this.currentUser.user_name && this.currentUser.user_name.length > 50) {
      validationErrors.push('Tên người dùng không được vượt quá 50 ký tự');
    }

    // Validate HocPhiList
    if (this.hocPhiList && this.hocPhiList.length > 0) {
      this.hocPhiList.forEach((item, index) => {
        if (item.GhiChu && item.GhiChu.length > 500) {
          validationErrors.push(`Ghi chú học phí (dòng ${index + 1}) không được vượt quá 500 ký tự`);
        }
      });
    }

    if (validationErrors.length > 0) {
      swal('Lỗi!', validationErrors.join('\n'), 'error');
      return;
    }

    this.isSubmitting = true;

    // Helper function to truncate strings safely
    const truncateString = (str: string, maxLength: number): string => {
      if (!str) return str;
      return str.length > maxLength ? str.substring(0, maxLength) : str;
    };

    // Helper function to format date to MM/dd/yyyy string
    const formatDateToMMddyyyy = (date: any): string | null => {
      if (!date) return null;

      try {
        let dateObj: Date;

        if (date instanceof Date) {
          dateObj = date;
        } else if (typeof date === 'string') {
          dateObj = new Date(date);
        } else {
          return null;
        }

        if (isNaN(dateObj.getTime())) {
          return null;
        }

        // Format to MM/dd/yyyy
        const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
        const day = dateObj.getDate().toString().padStart(2, '0');
        const year = dateObj.getFullYear().toString();

        return `${month}/${day}/${year}`;
      } catch (error) {
        console.error('Date formatting error:', error);
        return null;
      }
    };

    // Tính toán NgayDangKy và NgayKetThuc từ HocPhiList (loại trừ bản ghi có Id khác null)
    const getMinMaxDatesFromHocPhiList = () => {
      if (!this.hocPhiList || this.hocPhiList.length === 0) {
        return {
          minDateText: formatDateToMMddyyyy(this.doituongSelect.NgayDangKy),
          maxDateText: formatDateToMMddyyyy(this.doituongSelect.NgayKetThuc)
        };
      }

      // Lọc các bản ghi không có Id (loại trừ công nợ cũ)
      const newDebtRecords = this.hocPhiList.filter(item => !item.Id || item.Id === null);

      if (newDebtRecords.length === 0) {
        // Nếu không có bản ghi mới, sử dụng giá trị từ doituongSelect
        return {
          minDateText: formatDateToMMddyyyy(this.doituongSelect.NgayDangKy),
          maxDateText: formatDateToMMddyyyy(this.doituongSelect.NgayKetThuc)
        };
      }

      // Tìm ngày nhỏ nhất và lớn nhất từ các bản ghi mới
      const validDates = newDebtRecords
        .map(item => ({
          ngayDangKy: item.NgayDangKy ? new Date(item.NgayDangKy) : null,
          ngayKetThuc: item.NgayKetThuc ? new Date(item.NgayKetThuc) : null
        }))
        .filter(dates => dates.ngayDangKy && dates.ngayKetThuc &&
          !isNaN(dates.ngayDangKy.getTime()) &&
          !isNaN(dates.ngayKetThuc.getTime()));

      if (validDates.length === 0) {
        // Nếu không có ngày hợp lệ, sử dụng giá trị từ doituongSelect
        return {
          minDateText: formatDateToMMddyyyy(this.doituongSelect.NgayDangKy),
          maxDateText: formatDateToMMddyyyy(this.doituongSelect.NgayKetThuc)
        };
      }

      // Tìm ngày nhỏ nhất từ NgayDangKy
      const minDate = validDates.reduce((min, current) => {
        return current.ngayDangKy < min ? current.ngayDangKy : min;
      }, validDates[0].ngayDangKy);

      // Tìm ngày lớn nhất từ NgayKetThuc
      const maxDate = validDates.reduce((max, current) => {
        return current.ngayKetThuc > max ? current.ngayKetThuc : max;
      }, validDates[0].ngayKetThuc);

      return {
        minDateText: formatDateToMMddyyyy(minDate),
        maxDateText: formatDateToMMddyyyy(maxDate)
      };
    };

    const { minDateText, maxDateText } = getMinMaxDatesFromHocPhiList();

    // Chuẩn bị dữ liệu để gửi với truncation
    const data = {
      DonViId: this.dviid,
      Username: truncateString(this.currentUser.user_name, 50),
      HocPhiInfo: {
        NhanSuId: this.currentHocVienId,
        LopId: this.currentLopId,
        NgayDangKy: minDateText, // Trả về dưới dạng text MM/dd/yyyy
        NgayKetThuc: maxDateText, // Trả về dưới dạng text MM/dd/yyyy
        KhoaHocId: this.doituongSelect.KhoaHocId || null,
        GiaPhi: this.getTotalHocPhi(false),
        DangKy: this.getTotalSoBuoi(),
        SoBuoi: this.getTotalSoBuoi(),
        DuocGiam: this.getTotalHocPhi(false) - this.getTotalThucThu(false),
        ThucThu: this.getTotalThucThu(false),
        LyDoGiam: truncateString(this.doituongSelect.LyDoGiam || '', 500),
        GhiChu: truncateString(this.doituongSelect.GhiChu || '', 500),
        DiemDanhChiTietId: this.doituongSelect.DiemDanhChiTietId || null
      },
      PhieuThuInfo: {
        QuyenSo: truncateString(this.phieuThu.QuyenSo || '', 50),
        SoPhieu: this.phieuThu.SoPhieu,
        ThuTruoc: this.phieuThu.ThuTruoc || 1,
        SoTien: this.phieuThu.SoTien,
        HinhThuc: this.phieuThu.HinhThuc,
        PhuongThuc: this.phieuThu.PhuongThuc,
        NgayChungTu: this.formatDateForAPI(this.phieuThu.NgayChungTu),
        GhiChu: truncateString(this.phieuThu.GhiChu || '', 500)
      },
      HocPhiList: (this.hocPhiList || []).map(item => ({
        ...item,
        NgayDangKy: this.formatDateForAPI(item.NgayDangKy),
        NgayKetThuc: this.formatDateForAPI(item.NgayKetThuc),
        GhiChu: truncateString(item.GhiChu || '', 500)
      }))
    };

    this.repo.postRequest('api/hocvien/taothuhocphisave', data).subscribe(result => {
      this.isSubmitting = false;
      if (result.success) {
        swal('Thành công!', 'Đã lưu thông tin thu học phí thành công!', 'success');
        this.save.emit(result);
      } else {
        swal('Lỗi!', result.message || 'Có lỗi xảy ra khi lưu dữ liệu!', 'error');
      }
    }, error => {
      this.isSubmitting = false;
      console.error('API Error:', error);
      swal('Lỗi!', 'Có lỗi xảy ra khi lưu dữ liệu!', 'error');
    });
  }




  // Helper function để format date
  private formatDateForAPI(date: any): string | null {
    if (!date) return null;

    try {
      let dateObj: Date;

      if (date instanceof Date) {
        dateObj = date;
      } else if (typeof date === 'string') {
        dateObj = new Date(date);
      } else {
        return null;
      }

      if (isNaN(dateObj.getTime())) {
        return null;
      }

      // Format to MM/dd/yyyy instead of ISO string
      const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
      const day = dateObj.getDate().toString().padStart(2, '0');
      const year = dateObj.getFullYear().toString();

      return `${month}/${day}/${year}`;
    } catch (error) {
      console.error('Date formatting error:', error);
      return null;
    }
  }
  /**
 * Xóa một dòng học phí khỏi danh sách (chỉ cho phép xóa công nợ cũ - có Id)
 * @param index - Index của dòng cần xóa
 */
  /**
   * Xóa một dòng học phí khỏi danh sách (chỉ cho phép xóa công nợ cũ - có Id)
   * @param index - Index của dòng cần xóa
   */
  removeHocPhiRow(index: number): void {
    // Kiểm tra điều kiện xóa
    if (!this.hocPhiList || this.hocPhiList.length === 0) {
      swal('Thông báo!', 'Không có dữ liệu để xóa!', 'warning');
      return;
    }

    if (index < 0 || index >= this.hocPhiList.length) {
      swal('Lỗi!', 'Dòng không hợp lệ!', 'error');
      return;
    }

    const itemToRemove = this.hocPhiList[index];

    // Chỉ cho phép xóa dòng có Id (công nợ cũ)
    if (!itemToRemove.Id || itemToRemove.Id === null) {
      swal('Thông báo!', 'Chỉ được phép xóa các khoản công nợ cũ!', 'warning');
      return;
    }

    // Lấy thông tin dòng bị xóa để hiển thị thông báo
    const amount = itemToRemove.GiaPhi ? itemToRemove.GiaPhi.toLocaleString('vi-VN') : '0';

    // Xác nhận xóa - sử dụng cấu trúc giống hocvienmain.component
    swal({
      title: 'Bạn muốn xóa khoản công nợ cũ này phải không?',
      text: `Khoản: ${itemToRemove.GhiChu || 'Không có mô tả'} với số tiền ${amount} VND`,
      icon: "warning",
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    })
      .then(willDelete => {
        if (willDelete) {
          this.performRemoveOldDebtRow(index);
        }
      });
  }

  /**
 * Thực hiện xóa dòng công nợ cũ và cập nhật lại tính toán
 * @param index - Index của dòng cần xóa
 */
  private performRemoveOldDebtRow(index: number): void {
    try {
      // Xóa dòng khỏi mảng
      this.hocPhiList.splice(index, 1);

      // Cập nhật lại doituongSelect từ dòng đầu tiên (nếu còn)
      if (this.hocPhiList.length > 0) {
        // Tìm dòng đầu tiên không có Id (công nợ mới) để làm dữ liệu chính
        const newDebtRow = this.hocPhiList.find(item => !item.Id || item.Id === null);
        if (newDebtRow) {
          this.doituongSelect = { ...newDebtRow };
        } else {
          // Nếu không có dòng công nợ mới, lấy dòng đầu tiên
          this.doituongSelect = { ...this.hocPhiList[0] };
        }
      }

      // KHÔNG cập nhật số tháng thu trước vì công nợ cũ không tính vào số tháng
      // this.updateThuTruocAfterRemove(); // Bỏ dòng này

      // Áp dụng lại giảm giá nếu có
      if (this.doituongSelect.DuocGiam) {
        this.changeDuocGiam();
      } else {
        // Chỉ cập nhật số tiền thu
        this.phieuThu.SoTien = this.getTotalThucThu();
      }

      // Hiển thị thông báo thành công
      swal('Thành công!', 'Đã xóa khoản công nợ cũ!', 'success');

      console.log('Removed old debt row, updated list:', this.hocPhiList);
    } catch (error) {
      console.error('Error removing old debt row:', error);
      swal('Lỗi!', 'Có lỗi xảy ra khi xóa khoản công nợ!', 'error');
    }
  }
  /**
 * Kiểm tra xem có thể xóa dòng hay không (chỉ cho phép xóa công nợ cũ có Id)
 * @param index - Index của dòng cần kiểm tra
 * @returns true nếu có thể xóa, false nếu không thể
 */
  canRemoveRow(index: number): boolean {
    if (!this.hocPhiList || index < 0 || index >= this.hocPhiList.length) {
      return false;
    }

    const item = this.hocPhiList[index];
    // Chỉ cho phép xóa dòng có Id (công nợ cũ)
    return item && item.Id && item.Id !== null;
  }

  /**
   * Kiểm tra xem dòng có phải là công nợ cũ không
   * @param item - Item cần kiểm tra
   * @returns true nếu là công nợ cũ, false nếu không
   */
  isOldDebt(item: any): boolean {
    return item && item.Id && item.Id !== null;
  }

  /**
   * Lấy số lượng dòng công nợ mới (không có Id)
   * @returns Số lượng dòng công nợ mới
   */
  getNewDebtRowsCount(): number {
    if (!this.hocPhiList || this.hocPhiList.length === 0) {
      return 0;
    }
    return this.hocPhiList.filter(item => !item.Id || item.Id === null).length;
  }

  /**
   * Lấy số lượng dòng công nợ cũ (có Id)
   * @returns Số lượng dòng công nợ cũ
   */
  getOldDebtRowsCount(): number {
    if (!this.hocPhiList || this.hocPhiList.length === 0) {
      return 0;
    }
    return this.hocPhiList.filter(item => item.Id && item.Id !== null).length;
  }
  export(type: string) {
    if (!this.phieuThu.SoPhieu) {
      swal('Lỗi!', 'Vui lòng lưu phiếu thu trước khi in!', 'error');
      return;
    }

    const params = {
      donviid: this.dviid,
      username: this.currentUser.user_name,
      id: this.phieuThu.Id,
      type: type
    };

    // Uncomment when API is ready
    // this.repo.exportRequest('api/taothuhocphi/export', params);
  }

  closeModal() {
    this.save.emit(null);
  }
}
